import React from 'react';
import { Shield, HelpCircle } from 'lucide-react';

/**
 * Компонент настроек Индивидуального инвестиционного счета (ИИС)
 */
const IISSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className={`p-4 rounded-lg border ${formData.useIIS ? 'bg-green-50 dark:bg-green-900/20 border-green-100 dark:border-green-800' : 'bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700'}`}>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-medium text-gray-900 dark:text-white flex items-center">
          <Shield className="w-5 h-5 mr-2 text-green-500" />
          Индивидуальный инвестиционный счет (ИИС)
        </h3>
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="useIIS"
            checked={formData.useIIS}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Использовать ИИС
          </span>
        </label>
      </div>

      {formData.useIIS && (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <fieldset className="mt-2">
                <legend className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Тип вычета по ИИС
                </legend>
                <div className="space-y-2">
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="iisType"
                      value="taxDeduction"
                      checked={formData.iisType === 'taxDeduction'}
                      onChange={handleInputChange}
                      className="form-radio"
                    />
                    <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                      Тип А - вычет на взносы
                    </span>
                  </label>
                  <label className="inline-flex items-center">
                    <input
                      type="radio"
                      name="iisType"
                      value="taxFree"
                      checked={formData.iisType === 'taxFree'}
                      onChange={handleInputChange}
                      className="form-radio"
                    />
                    <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
                      Тип Б - освобождение от НДФЛ
                    </span>
                  </label>
                </div>
              </fieldset>

              {formData.iisType === 'taxDeduction' && (
                <div className="mt-3">
                  <label htmlFor="iisDeductionLimit" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Лимит на вычет (₽/год)
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      id="iisDeductionLimit"
                      name="iisDeductionLimit"
                      value={formData.iisDeductionLimit}
                      onChange={handleInputChange}
                      className={`form-input w-full ${errors.iisDeductionLimit ? 'input-error' : ''}`}
                      placeholder="Введите лимит"
                    />
                    <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 pointer-events-none">
                      ₽
                    </span>
                  </div>
                  {errors.iisDeductionLimit && (
                    <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                      {errors.iisDeductionLimit}
                    </p>
                  )}
                </div>
              )}
            </div>

            <div className="bg-white dark:bg-gray-700 p-3 rounded-lg border border-gray-200 dark:border-gray-600">
              <div className="flex items-start">
                <HelpCircle className="w-5 h-5 text-green-600 dark:text-green-400 mt-0.5 mr-2 flex-shrink-0" />
                <div>
                  <h4 className="text-sm font-medium text-gray-800 dark:text-gray-100 mb-1">
                    {formData.iisType === 'taxDeduction' 
                      ? 'ИИС типа А: налоговый вычет 13%' 
                      : 'ИИС типа Б: освобождение от НДФЛ'}
                  </h4>
                  <p className="text-xs text-gray-600 dark:text-gray-400">
                    {formData.iisType === 'taxDeduction' 
                      ? `Возврат 13% от суммы взносов (до ${new Intl.NumberFormat('ru-RU').format(formData.iisDeductionLimit)} ₽ в год). Максимальная выгода - ${new Intl.NumberFormat('ru-RU').format(formData.iisDeductionLimit * 0.13)} ₽/год. Подходит для тех, кто имеет официальный доход и платит НДФЛ.` 
                      : 'Освобождение от НДФЛ с доходов по операциям на ИИС. Подходит для агрессивных стратегий с высокой ожидаемой доходностью.'}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-3 bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-lg border border-yellow-100 dark:border-yellow-800">
            <p className="text-sm text-yellow-700 dark:text-yellow-300">
              <strong>Важно:</strong> Срок действия ИИС - минимум 3 года. При досрочном закрытии счета все полученные налоговые льготы придется вернуть.
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default IISSection;